import { BrowserRouter, Route } from "react-router-dom";
import { Admin, CustomRoutes, Resource } from "react-admin";
import Dashboard from "./components/common/Dashboard";
import { Layout } from "./react-admin/components/Layout";
import dataProvider from "./react-admin/providers/dataProvider";
import { UsersList } from "./components/UsersList";
import authProvider from "./react-admin/providers/authProvider";
import { CustomLoginPage } from "./pages/Login";
import { Auth } from "./pages/Auth";
import { ThreadList } from "./components/ThreadList";
import { CurriculaList } from "./components/curriculum/CurriculaList";
import { CurriculumDetail } from "./components/curriculum/CurriculumDetail";
import { LessonEditor } from "./components/curriculum/LessonEditor";
import { LearningDashboard } from "./components/learning/LearningDashboard";
import { LearningUsersList } from "./components/learning/LearningUsersList";
import { UserLearningProgress } from "./components/learning/UserLearningProgress";

const App = () => {
  return (
    <BrowserRouter>
      <Admin
        dashboard={Dashboard}
        layout={Layout}
        dataProvider={dataProvider}
        authProvider={authProvider}
        loginPage={CustomLoginPage}
        disableTelemetry
      >
        <Resource name="users" list={UsersList} />
        <Resource name="curricula" list={CurriculaList} />
        <Resource name="learning-users" list={LearningUsersList} />
        <CustomRoutes>
          <Route path="/auth" element={<Auth />} />
          <Route path="/threads/:userId" element={<ThreadList />} />
          <Route
            path="/curricula/:curriculumId"
            element={<CurriculumDetail />}
          />
          <Route path="/lessons/:lessonId/edit" element={<LessonEditor />} />
          <Route path="/learning/*" element={<LearningDashboard />} />
          <Route
            path="/users/:userId/learning"
            element={<UserLearningProgress />}
          />
        </CustomRoutes>
      </Admin>
    </BrowserRouter>
  );
};

export default App;
